import axios from 'axios';

const AUTH_API_URL = process.env.VUE_APP_AUTH_API_BASE_URL + 'account/';
const API_URL = process.env.VUE_APP_API_BASE_URL + 'accounts/';
const DEL_URL = process.env.VUE_APP_API_BASE_URL + 'users/';

class AccountService {

  get() {
    var full_api_url = API_URL;
  
    return axios
    .get(full_api_url, { headers: { Authorization: 'Bearer '+ localStorage.getItem("token")} })
    .then(response => {
      return response.data;
    });
  }


  check(email) {
    var full_api_url = AUTH_API_URL + "check?email=" + email;

    return axios
      .post(full_api_url)
      .then(response => {
        return response;
      });
  }

  verify(code, email) {
    var full_api_url = AUTH_API_URL + "verify";
   
    let params = {
      to: email,
      code: code
    };

    return axios
      .post(full_api_url, params)
      .then(response => {
        return response;
      });
    }

    delete() {
      var full_api_url = DEL_URL;
     
      return axios
      .delete(full_api_url, { headers: { Authorization: 'Bearer '+ localStorage.getItem("token")} })
      .then(response => {
        return response;
      });
    }
    
    addReasons(reasons) {
      var full_api_url = DEL_URL + "delete_reasons";
      let params = {
        reason_ids: reasons
      };
  
      return axios
        .post(full_api_url, params,  { headers: { Authorization: 'Bearer '+ localStorage.getItem("token")}})
        .then(response => {
          return response;
        });
      }
}



export default new AccountService();
